import {selectRandom} from "../../../utils/random";

export const mockDedupeData = () => [
    {
        "address": "123 MAIN STREET",
        "city": "SPRINGFIELD",
        "state": "IL",
        "zip": "62701",
        "count": selectRandom([0,1]),
    },
    // {
    //     "address": "456 ELM AVENUE",
    //     "city": "EL PASO",
    //     "state": "TX",
    //     "zip": "79905",
    //     "count": 2
    // },
    // {
    //     "address": "789 OAK ROAD",
    //     "city": "MIAMI",
    //     "state": "FL",
    //     "zip": "33101",
    //     "count": 3
    // },
    // {
    //     "address": "987 PINE STREET",
    //     "city": "DENVER",
    //     "state": "CO",
    //     "zip": "80201",
    //     "count": 1
    // },
    // {
    //     "address": "654 MAPLE DRIVE",
    //     "city": "PHOENIX",
    //     "state": "AZ",
    //     "zip": "85001",
    //     "count": 2
    // },
    // {
    //     "address": "111 CHERRY LANE",
    //     "city": "SEATTLE",
    //     "state": "WA",
    //     "zip": "98101",
    //     "count": 3
    // },
    // {
    //     "address": "222 WALNUT STREET",
    //     "city": "PORTLAND",
    //     "state": "OR",
    //     "zip": "97201",
    //     "count": 1
    // },
    // {
    //     "address": "333 CEDAR AVENUE",
    //     "city": "AUSTIN",
    //     "state": "TX",
    //     "zip": "78701",
    //     "count": 2
    // },
    // {
    //     "address": "444 BIRCH ROAD",
    //     "city": "CHICAGO",
    //     "state": "IL",
    //     "zip": "60601",
    //     "count": 1
    // },
    // {
    //     "address": "555 OAK STREET",
    //     "city": "SAN FRANCISCO",
    //     "state": "CA",
    //     "zip": "94101",
    //     "count": 3
    // },
    // {
    //     "address": "666 MAPLE AVENUE",
    //     "city": "NEW YORK",
    //     "state": "NY",
    //     "zip": "10001",
    //     "count": 2
    // },
    // {
    //     "address": "777 ELM DRIVE",
    //     "city": "LOS ANGELES",
    //     "state": "CA",
    //     "zip": "90001",
    //     "count": 1
    // },
    // {
    //     "address": "888 PINE LANE",
    //     "city": "ATLANTA",
    //     "state": "GA",
    //     "zip": "30301",
    //     "count": 2
    // },
    // {
    //     "address": "999 CHERRY STREET",
    //     "city": "DALLAS",
    //     "state": "TX",
    //     "zip": "75201",
    //     "count": 3
    // },
    // {
    //     "address": "1010 WALNUT AVENUE",
    //     "city": "MIAMI",
    //     "state": "FL",
    //     "zip": "33101",
    //     "count": 1
    // },
    // {
    //     "address": "1212 CEDAR ROAD",
    //     "city": "DENVER",
    //     "state": "CO",
    //     "zip": "80201",
    //     "count": 2
    // },
    // {
    //     "address": "1313 BIRCH STREET",
    //     "city": "PHOENIX",
    //     "state": "AZ",
    //     "zip": "85001",
    //     "count": 3
    // },
    // {
    //     "address": "1414 MAPLE DRIVE",
    //     "city": "SPRINGFIELD",
    //     "state": "IL",
    //     "zip": "62701",
    //     "count": 1
    // },
    // {
    //     "address": "1515 OAK ROAD",
    //     "city": "EL PASO",
    //     "state": "TX",
    //     "zip": "79905",
    //     "count": 2
    // },
    // {
    //     "address": "1616 PINE LANE",
    //     "city": "SEATTLE",
    //     "state": "WA",
    //     "zip": "98101",
    //     "count": 1
    // },
    // {
    //     "address": "1717 WALNUT STREET",
    //     "city": "PORTLAND",
    //     "state": "OR",
    //     "zip": "97201",
    //     "count": 3
    // },
    // {
    //     "address": "1818 CEDAR AVENUE",
    //     "city": "AUSTIN",
    //     "state": "TX",
    //     "zip": "78701",
    //     "count": 2
    // },
    // {
    //     "address": "1919 BIRCH ROAD",
    //     "city": "CHICAGO",
    //     "state": "IL",
    //     "zip": "60601",
    //     "count": 1
    // },
    // {
    //     "address": "2020 OAK STREET",
    //     "city": "SAN FRANCISCO",
    //     "state": "CA",
    //     "zip": "94101",
    //     "count": 2
    // },
    // {
    //     "address": "2121 MAPLE AVENUE",
    //     "city": "NEW YORK",
    //     "state": "NY",
    //     "zip": "10001",
    //     "count": 3
    // },
];
